/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const newTimesheet = /* GraphQL */ `
  mutation NewTimesheet($input: NewTimesheetInput) {
    newTimesheet(input: $input) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      timeEntries {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      customers {
        id
        number
        name
        active
        locationId
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      hours
      allApproved
      date
      isApproved
      __typename
    }
  }
`;
export const newDailyReport = /* GraphQL */ `
  mutation NewDailyReport($input: NewDailyReportInput) {
    newDailyReport(input: $input) {
      id
      submissionDate
      summary
      isCompleted
      anyoneInjured
      qaqcCompleted
      siteSecured
      pdfKey
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      media {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      type
      inspectionType
      foremanName
      customerName
      address
      taskArea
      weather
      correctiveActions {
        action
        dueDate
        assignedTo
        signature
        __typename
      }
      inspectionQuestion
      foremanSignature
      safetySignature
      __typename
    }
  }
`;
export const sendDocumentByEmail = /* GraphQL */ `
  mutation SendDocumentByEmail($input: SendDocumentByEmailInput) {
    sendDocumentByEmail(input: $input) {
      status
      message
      __typename
    }
  }
`;
export const adminCreateUser = /* GraphQL */ `
  mutation AdminCreateUser($input: NewUserInput) {
    adminCreateUser(input: $input) {
      id
      email
      firstName
      lastName
      phoneNumber
      expoPushToken
      isNotificationEnabled
      role
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      hasDivisionAccess
      groups {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      divisions {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const adminDeleteUser = /* GraphQL */ `
  mutation AdminDeleteUser($input: DeleteUserInput) {
    adminDeleteUser(input: $input) {
      status
      message
      __typename
    }
  }
`;
export const generateTimeEntryReport = /* GraphQL */ `
  mutation GenerateTimeEntryReport($input: GenerateTimeEntryReportInput) {
    generateTimeEntryReport(input: $input) {
      status
      message
      url
      filename
      __typename
    }
  }
`;
export const exportDailyReport = /* GraphQL */ `
  mutation ExportDailyReport($input: ExportDailyReportInput) {
    exportDailyReport(input: $input) {
      status
      message
      url
      filename
      __typename
    }
  }
`;
export const emailDailyReport = /* GraphQL */ `
  mutation EmailDailyReport($input: EmailDailyReportInput) {
    emailDailyReport(input: $input) {
      status
      message
      __typename
    }
  }
`;
export const generatePayrollReport = /* GraphQL */ `
  mutation GeneratePayrollReport($input: GeneratePayrollReportInput) {
    generatePayrollReport(input: $input) {
      status
      message
      url
      filename
      __typename
    }
  }
`;
export const sendDailyTimeReport = /* GraphQL */ `
  mutation SendDailyTimeReport {
    sendDailyTimeReport {
      status
      message
      __typename
    }
  }
`;
export const setUserPassword = /* GraphQL */ `
  mutation SetUserPassword($input: SetUserPasswordInput) {
    setUserPassword(input: $input) {
      status
      message
      __typename
    }
  }
`;
export const sendHeadsUpMessage = /* GraphQL */ `
  mutation SendHeadsUpMessage($input: SendHeadsUpMessageInput) {
    sendHeadsUpMessage(input: $input) {
      status
      message
      __typename
    }
  }
`;
export const startLongProcess = /* GraphQL */ `
  mutation StartLongProcess($input: StartLongProcessInput) {
    startLongProcess(input: $input) {
      status
      message
      __typename
    }
  }
`;
export const setUserGroups = /* GraphQL */ `
  mutation SetUserGroups($input: SetUserGroupsInput) {
    setUserGroups(input: $input) {
      status
      message
      __typename
    }
  }
`;
export const batchPutNotification = /* GraphQL */ `
  mutation BatchPutNotification($notifications: [BatchPutNotification]) {
    batchPutNotification(notifications: $notifications) {
      id
      hasViewed
      status
      subject
      body
      content
      date
      expiry
      userId
      __typename
    }
  }
`;
export const createAddressBook = /* GraphQL */ `
  mutation CreateAddressBook(
    $input: CreateAddressBookInput!
    $condition: ModelAddressBookConditionInput
  ) {
    createAddressBook(input: $input, condition: $condition) {
      email
      userId
      expiry
      __typename
    }
  }
`;
export const updateAddressBook = /* GraphQL */ `
  mutation UpdateAddressBook(
    $input: UpdateAddressBookInput!
    $condition: ModelAddressBookConditionInput
  ) {
    updateAddressBook(input: $input, condition: $condition) {
      email
      userId
      expiry
      __typename
    }
  }
`;
export const deleteAddressBook = /* GraphQL */ `
  mutation DeleteAddressBook(
    $input: DeleteAddressBookInput!
    $condition: ModelAddressBookConditionInput
  ) {
    deleteAddressBook(input: $input, condition: $condition) {
      email
      userId
      expiry
      __typename
    }
  }
`;
export const createCompletedDocument = /* GraphQL */ `
  mutation CreateCompletedDocument(
    $input: CreateCompletedDocumentInput!
    $condition: ModelCompletedDocumentConditionInput
  ) {
    createCompletedDocument(input: $input, condition: $condition) {
      id
      name
      pdfKey
      draft
      locked
      lockedBy {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      lockedById
      annotations
      templateId
      template {
        id
        name
        pdfKey
        summary
        fillable
        daysUntilFinalized
        folderId
        createdBy
        createdAt
        updatedBy
        updatedAt
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      creator {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      createdBy
      createdAt
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      foremanId
      updator {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      updatedBy
      updatedAt
      finalizeAfter
      authors
      __typename
    }
  }
`;
export const updateCompletedDocument = /* GraphQL */ `
  mutation UpdateCompletedDocument(
    $input: UpdateCompletedDocumentInput!
    $condition: ModelCompletedDocumentConditionInput
  ) {
    updateCompletedDocument(input: $input, condition: $condition) {
      id
      name
      pdfKey
      draft
      locked
      lockedBy {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      lockedById
      annotations
      templateId
      template {
        id
        name
        pdfKey
        summary
        fillable
        daysUntilFinalized
        folderId
        createdBy
        createdAt
        updatedBy
        updatedAt
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      creator {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      createdBy
      createdAt
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      foremanId
      updator {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      updatedBy
      updatedAt
      finalizeAfter
      authors
      __typename
    }
  }
`;
export const deleteCompletedDocument = /* GraphQL */ `
  mutation DeleteCompletedDocument(
    $input: DeleteCompletedDocumentInput!
    $condition: ModelCompletedDocumentConditionInput
  ) {
    deleteCompletedDocument(input: $input, condition: $condition) {
      id
      name
      pdfKey
      draft
      locked
      lockedBy {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      lockedById
      annotations
      templateId
      template {
        id
        name
        pdfKey
        summary
        fillable
        daysUntilFinalized
        folderId
        createdBy
        createdAt
        updatedBy
        updatedAt
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      creator {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      createdBy
      createdAt
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      foremanId
      updator {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      updatedBy
      updatedAt
      finalizeAfter
      authors
      __typename
    }
  }
`;
export const createCrewMember = /* GraphQL */ `
  mutation CreateCrewMember(
    $input: CreateCrewMemberInput!
    $condition: ModelCrewMemberConditionInput
  ) {
    createCrewMember(input: $input, condition: $condition) {
      id
      active
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      rateOverride {
        crewMemberId
        locationId
        rate
        __typename
      }
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      email
      name
      rate
      crewMemberUserId
      __typename
    }
  }
`;
export const updateCrewMember = /* GraphQL */ `
  mutation UpdateCrewMember(
    $input: UpdateCrewMemberInput!
    $condition: ModelCrewMemberConditionInput
  ) {
    updateCrewMember(input: $input, condition: $condition) {
      id
      active
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      rateOverride {
        crewMemberId
        locationId
        rate
        __typename
      }
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      email
      name
      rate
      crewMemberUserId
      __typename
    }
  }
`;
export const deleteCrewMember = /* GraphQL */ `
  mutation DeleteCrewMember(
    $input: DeleteCrewMemberInput!
    $condition: ModelCrewMemberConditionInput
  ) {
    deleteCrewMember(input: $input, condition: $condition) {
      id
      active
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      rateOverride {
        crewMemberId
        locationId
        rate
        __typename
      }
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      email
      name
      rate
      crewMemberUserId
      __typename
    }
  }
`;
export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      id
      number
      name
      active
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      __typename
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      number
      name
      active
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      __typename
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      id
      number
      name
      active
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      __typename
    }
  }
`;
export const createDailyReport = /* GraphQL */ `
  mutation CreateDailyReport(
    $input: CreateDailyReportInput!
    $condition: ModelDailyReportConditionInput
  ) {
    createDailyReport(input: $input, condition: $condition) {
      id
      submissionDate
      summary
      isCompleted
      anyoneInjured
      qaqcCompleted
      siteSecured
      pdfKey
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      media {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      type
      inspectionType
      foremanName
      customerName
      address
      taskArea
      weather
      correctiveActions {
        action
        dueDate
        assignedTo
        signature
        __typename
      }
      inspectionQuestion
      foremanSignature
      safetySignature
      __typename
    }
  }
`;
export const updateDailyReport = /* GraphQL */ `
  mutation UpdateDailyReport(
    $input: UpdateDailyReportInput!
    $condition: ModelDailyReportConditionInput
  ) {
    updateDailyReport(input: $input, condition: $condition) {
      id
      submissionDate
      summary
      isCompleted
      anyoneInjured
      qaqcCompleted
      siteSecured
      pdfKey
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      media {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      type
      inspectionType
      foremanName
      customerName
      address
      taskArea
      weather
      correctiveActions {
        action
        dueDate
        assignedTo
        signature
        __typename
      }
      inspectionQuestion
      foremanSignature
      safetySignature
      __typename
    }
  }
`;
export const deleteDailyReport = /* GraphQL */ `
  mutation DeleteDailyReport(
    $input: DeleteDailyReportInput!
    $condition: ModelDailyReportConditionInput
  ) {
    deleteDailyReport(input: $input, condition: $condition) {
      id
      submissionDate
      summary
      isCompleted
      anyoneInjured
      qaqcCompleted
      siteSecured
      pdfKey
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      media {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      type
      inspectionType
      foremanName
      customerName
      address
      taskArea
      weather
      correctiveActions {
        action
        dueDate
        assignedTo
        signature
        __typename
      }
      inspectionQuestion
      foremanSignature
      safetySignature
      __typename
    }
  }
`;
export const createDocument = /* GraphQL */ `
  mutation CreateDocument(
    $input: CreateDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    createDocument(input: $input, condition: $condition) {
      id
      name
      pdfKey
      summary
      fillable
      daysUntilFinalized
      folderId
      folder {
        id
        name
        parentId
        __typename
      }
      createdBy
      creator {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updator {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      updatedBy
      updatedAt
      __typename
    }
  }
`;
export const updateDocument = /* GraphQL */ `
  mutation UpdateDocument(
    $input: UpdateDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    updateDocument(input: $input, condition: $condition) {
      id
      name
      pdfKey
      summary
      fillable
      daysUntilFinalized
      folderId
      folder {
        id
        name
        parentId
        __typename
      }
      createdBy
      creator {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updator {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      updatedBy
      updatedAt
      __typename
    }
  }
`;
export const deleteDocument = /* GraphQL */ `
  mutation DeleteDocument(
    $input: DeleteDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    deleteDocument(input: $input, condition: $condition) {
      id
      name
      pdfKey
      summary
      fillable
      daysUntilFinalized
      folderId
      folder {
        id
        name
        parentId
        __typename
      }
      createdBy
      creator {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updator {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      updatedBy
      updatedAt
      __typename
    }
  }
`;
export const createFolder = /* GraphQL */ `
  mutation CreateFolder(
    $input: CreateFolderInput!
    $condition: ModelFolderConditionInput
  ) {
    createFolder(input: $input, condition: $condition) {
      id
      name
      parentId
      parent {
        id
        name
        parentId
        __typename
      }
      __typename
    }
  }
`;
export const updateFolder = /* GraphQL */ `
  mutation UpdateFolder(
    $input: UpdateFolderInput!
    $condition: ModelFolderConditionInput
  ) {
    updateFolder(input: $input, condition: $condition) {
      id
      name
      parentId
      parent {
        id
        name
        parentId
        __typename
      }
      __typename
    }
  }
`;
export const deleteFolder = /* GraphQL */ `
  mutation DeleteFolder(
    $input: DeleteFolderInput!
    $condition: ModelFolderConditionInput
  ) {
    deleteFolder(input: $input, condition: $condition) {
      id
      name
      parentId
      parent {
        id
        name
        parentId
        __typename
      }
      __typename
    }
  }
`;
export const createGroup = /* GraphQL */ `
  mutation CreateGroup(
    $input: CreateGroupInput!
    $condition: ModelGroupConditionInput
  ) {
    createGroup(input: $input, condition: $condition) {
      id
      name
      division
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      createdAt
      crewMemberIds
      members {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      __typename
    }
  }
`;
export const updateGroup = /* GraphQL */ `
  mutation UpdateGroup(
    $input: UpdateGroupInput!
    $condition: ModelGroupConditionInput
  ) {
    updateGroup(input: $input, condition: $condition) {
      id
      name
      division
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      createdAt
      crewMemberIds
      members {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      __typename
    }
  }
`;
export const deleteGroup = /* GraphQL */ `
  mutation DeleteGroup(
    $input: DeleteGroupInput!
    $condition: ModelGroupConditionInput
  ) {
    deleteGroup(input: $input, condition: $condition) {
      id
      name
      division
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      createdAt
      crewMemberIds
      members {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      __typename
    }
  }
`;
export const createLocation = /* GraphQL */ `
  mutation CreateLocation(
    $input: CreateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    createLocation(input: $input, condition: $condition) {
      id
      name
      phoneNumber
      address
      address1
      city
      province
      postalCode
      maxDailyHours
      maxWeeklyHours
      utcOffset
      payPeriodStart
      syncTasks
      dailyTimeReportReceivers {
        email
        __typename
      }
      mediaTargetFilesize
      mediaCompression
      termsOfUseURL
      privacyURL
      supportURL
      __typename
    }
  }
`;
export const updateLocation = /* GraphQL */ `
  mutation UpdateLocation(
    $input: UpdateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    updateLocation(input: $input, condition: $condition) {
      id
      name
      phoneNumber
      address
      address1
      city
      province
      postalCode
      maxDailyHours
      maxWeeklyHours
      utcOffset
      payPeriodStart
      syncTasks
      dailyTimeReportReceivers {
        email
        __typename
      }
      mediaTargetFilesize
      mediaCompression
      termsOfUseURL
      privacyURL
      supportURL
      __typename
    }
  }
`;
export const deleteLocation = /* GraphQL */ `
  mutation DeleteLocation(
    $input: DeleteLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    deleteLocation(input: $input, condition: $condition) {
      id
      name
      phoneNumber
      address
      address1
      city
      province
      postalCode
      maxDailyHours
      maxWeeklyHours
      utcOffset
      payPeriodStart
      syncTasks
      dailyTimeReportReceivers {
        email
        __typename
      }
      mediaTargetFilesize
      mediaCompression
      termsOfUseURL
      privacyURL
      supportURL
      __typename
    }
  }
`;
export const createLongProcess = /* GraphQL */ `
  mutation CreateLongProcess(
    $input: CreateLongProcessInput!
    $condition: ModelLongProcessConditionInput
  ) {
    createLongProcess(input: $input, condition: $condition) {
      id
      processName
      status
      params
      startedAt
      updatedAt
      userId
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      expiry
      __typename
    }
  }
`;
export const updateLongProcess = /* GraphQL */ `
  mutation UpdateLongProcess(
    $input: UpdateLongProcessInput!
    $condition: ModelLongProcessConditionInput
  ) {
    updateLongProcess(input: $input, condition: $condition) {
      id
      processName
      status
      params
      startedAt
      updatedAt
      userId
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      expiry
      __typename
    }
  }
`;
export const deleteLongProcess = /* GraphQL */ `
  mutation DeleteLongProcess(
    $input: DeleteLongProcessInput!
    $condition: ModelLongProcessConditionInput
  ) {
    deleteLongProcess(input: $input, condition: $condition) {
      id
      processName
      status
      params
      startedAt
      updatedAt
      userId
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      expiry
      __typename
    }
  }
`;
export const createMedia = /* GraphQL */ `
  mutation CreateMedia(
    $input: CreateMediaInput!
    $condition: ModelMediaConditionInput
  ) {
    createMedia(input: $input, condition: $condition) {
      id
      filename
      mediaType
      description
      sortKey
      dailyReportId
      dailyReport {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        inspectionType
        foremanName
        customerName
        address
        taskArea
        weather
        inspectionQuestion
        foremanSignature
        safetySignature
        __typename
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      createdAt
      customerId
      locationId
      __typename
    }
  }
`;
export const updateMedia = /* GraphQL */ `
  mutation UpdateMedia(
    $input: UpdateMediaInput!
    $condition: ModelMediaConditionInput
  ) {
    updateMedia(input: $input, condition: $condition) {
      id
      filename
      mediaType
      description
      sortKey
      dailyReportId
      dailyReport {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        inspectionType
        foremanName
        customerName
        address
        taskArea
        weather
        inspectionQuestion
        foremanSignature
        safetySignature
        __typename
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      createdAt
      customerId
      locationId
      __typename
    }
  }
`;
export const deleteMedia = /* GraphQL */ `
  mutation DeleteMedia(
    $input: DeleteMediaInput!
    $condition: ModelMediaConditionInput
  ) {
    deleteMedia(input: $input, condition: $condition) {
      id
      filename
      mediaType
      description
      sortKey
      dailyReportId
      dailyReport {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        inspectionType
        foremanName
        customerName
        address
        taskArea
        weather
        inspectionQuestion
        foremanSignature
        safetySignature
        __typename
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      createdAt
      customerId
      locationId
      __typename
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification(
    $input: CreateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    createNotification(input: $input, condition: $condition) {
      id
      hasViewed
      status
      subject
      body
      content
      date
      expiry
      userId
      __typename
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification(
    $input: UpdateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    updateNotification(input: $input, condition: $condition) {
      id
      hasViewed
      status
      subject
      body
      content
      date
      expiry
      userId
      __typename
    }
  }
`;
export const deleteNotification = /* GraphQL */ `
  mutation DeleteNotification(
    $input: DeleteNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    deleteNotification(input: $input, condition: $condition) {
      id
      hasViewed
      status
      subject
      body
      content
      date
      expiry
      userId
      __typename
    }
  }
`;
export const createQBSync = /* GraphQL */ `
  mutation CreateQBSync(
    $input: CreateQBSyncInput!
    $condition: ModelQBSyncConditionInput
  ) {
    createQBSync(input: $input, condition: $condition) {
      id
      sessionId
      session {
        id
        locationId
        expiry
        createdAt
        __typename
      }
      task
      status
      data
      createdAt
      expiry
      __typename
    }
  }
`;
export const updateQBSync = /* GraphQL */ `
  mutation UpdateQBSync(
    $input: UpdateQBSyncInput!
    $condition: ModelQBSyncConditionInput
  ) {
    updateQBSync(input: $input, condition: $condition) {
      id
      sessionId
      session {
        id
        locationId
        expiry
        createdAt
        __typename
      }
      task
      status
      data
      createdAt
      expiry
      __typename
    }
  }
`;
export const deleteQBSync = /* GraphQL */ `
  mutation DeleteQBSync(
    $input: DeleteQBSyncInput!
    $condition: ModelQBSyncConditionInput
  ) {
    deleteQBSync(input: $input, condition: $condition) {
      id
      sessionId
      session {
        id
        locationId
        expiry
        createdAt
        __typename
      }
      task
      status
      data
      createdAt
      expiry
      __typename
    }
  }
`;
export const createRateOverride = /* GraphQL */ `
  mutation CreateRateOverride(
    $input: CreateRateOverrideInput!
    $condition: ModelRateOverrideConditionInput
  ) {
    createRateOverride(input: $input, condition: $condition) {
      crewMemberId
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      rate
      __typename
    }
  }
`;
export const updateRateOverride = /* GraphQL */ `
  mutation UpdateRateOverride(
    $input: UpdateRateOverrideInput!
    $condition: ModelRateOverrideConditionInput
  ) {
    updateRateOverride(input: $input, condition: $condition) {
      crewMemberId
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      rate
      __typename
    }
  }
`;
export const deleteRateOverride = /* GraphQL */ `
  mutation DeleteRateOverride(
    $input: DeleteRateOverrideInput!
    $condition: ModelRateOverrideConditionInput
  ) {
    deleteRateOverride(input: $input, condition: $condition) {
      crewMemberId
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      rate
      __typename
    }
  }
`;
export const createScope = /* GraphQL */ `
  mutation CreateScope(
    $input: CreateScopeInput!
    $condition: ModelScopeConditionInput
  ) {
    createScope(input: $input, condition: $condition) {
      id
      name
      fullName
      account
      active
      locationId
      __typename
    }
  }
`;
export const updateScope = /* GraphQL */ `
  mutation UpdateScope(
    $input: UpdateScopeInput!
    $condition: ModelScopeConditionInput
  ) {
    updateScope(input: $input, condition: $condition) {
      id
      name
      fullName
      account
      active
      locationId
      __typename
    }
  }
`;
export const deleteScope = /* GraphQL */ `
  mutation DeleteScope(
    $input: DeleteScopeInput!
    $condition: ModelScopeConditionInput
  ) {
    deleteScope(input: $input, condition: $condition) {
      id
      name
      fullName
      account
      active
      locationId
      __typename
    }
  }
`;
export const createSession = /* GraphQL */ `
  mutation CreateSession(
    $input: CreateSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    createSession(input: $input, condition: $condition) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      expiry
      createdAt
      tasks {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateSession = /* GraphQL */ `
  mutation UpdateSession(
    $input: UpdateSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    updateSession(input: $input, condition: $condition) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      expiry
      createdAt
      tasks {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteSession = /* GraphQL */ `
  mutation DeleteSession(
    $input: DeleteSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    deleteSession(input: $input, condition: $condition) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      expiry
      createdAt
      tasks {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createTimeEntry = /* GraphQL */ `
  mutation CreateTimeEntry(
    $input: CreateTimeEntryInput!
    $condition: ModelTimeEntryConditionInput
  ) {
    createTimeEntry(input: $input, condition: $condition) {
      id
      date
      scopeId
      scope {
        id
        name
        fullName
        account
        active
        locationId
        __typename
      }
      hours
      adjustedHours {
        straightTime
        overtime
        __typename
      }
      isApproved
      timeSheetId
      timeSheet {
        id
        locationId
        customerId
        foremanId
        userId
        hours
        allApproved
        date
        isApproved
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      status
      syncStatusMessage
      __typename
    }
  }
`;
export const updateTimeEntry = /* GraphQL */ `
  mutation UpdateTimeEntry(
    $input: UpdateTimeEntryInput!
    $condition: ModelTimeEntryConditionInput
  ) {
    updateTimeEntry(input: $input, condition: $condition) {
      id
      date
      scopeId
      scope {
        id
        name
        fullName
        account
        active
        locationId
        __typename
      }
      hours
      adjustedHours {
        straightTime
        overtime
        __typename
      }
      isApproved
      timeSheetId
      timeSheet {
        id
        locationId
        customerId
        foremanId
        userId
        hours
        allApproved
        date
        isApproved
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      status
      syncStatusMessage
      __typename
    }
  }
`;
export const deleteTimeEntry = /* GraphQL */ `
  mutation DeleteTimeEntry(
    $input: DeleteTimeEntryInput!
    $condition: ModelTimeEntryConditionInput
  ) {
    deleteTimeEntry(input: $input, condition: $condition) {
      id
      date
      scopeId
      scope {
        id
        name
        fullName
        account
        active
        locationId
        __typename
      }
      hours
      adjustedHours {
        straightTime
        overtime
        __typename
      }
      isApproved
      timeSheetId
      timeSheet {
        id
        locationId
        customerId
        foremanId
        userId
        hours
        allApproved
        date
        isApproved
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      status
      syncStatusMessage
      __typename
    }
  }
`;
export const createTimeSheet = /* GraphQL */ `
  mutation CreateTimeSheet(
    $input: CreateTimeSheetInput!
    $condition: ModelTimeSheetConditionInput
  ) {
    createTimeSheet(input: $input, condition: $condition) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      timeEntries {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      customers {
        id
        number
        name
        active
        locationId
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      hours
      allApproved
      date
      isApproved
      __typename
    }
  }
`;
export const updateTimeSheet = /* GraphQL */ `
  mutation UpdateTimeSheet(
    $input: UpdateTimeSheetInput!
    $condition: ModelTimeSheetConditionInput
  ) {
    updateTimeSheet(input: $input, condition: $condition) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      timeEntries {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      customers {
        id
        number
        name
        active
        locationId
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      hours
      allApproved
      date
      isApproved
      __typename
    }
  }
`;
export const deleteTimeSheet = /* GraphQL */ `
  mutation DeleteTimeSheet(
    $input: DeleteTimeSheetInput!
    $condition: ModelTimeSheetConditionInput
  ) {
    deleteTimeSheet(input: $input, condition: $condition) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      timeEntries {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      customers {
        id
        number
        name
        active
        locationId
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      hours
      allApproved
      date
      isApproved
      __typename
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      phoneNumber
      expoPushToken
      isNotificationEnabled
      role
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      hasDivisionAccess
      groups {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      divisions {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      phoneNumber
      expoPushToken
      isNotificationEnabled
      role
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      hasDivisionAccess
      groups {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      divisions {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      phoneNumber
      expoPushToken
      isNotificationEnabled
      role
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      hasDivisionAccess
      groups {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      divisions {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
